import { API_BASE_URL, endpoints } from "./config";
import { authHeadersForGet, authHeadersJson } from "./http";
import { Category } from "../types/category";

export const categoriesApi = {
  getAll: async (): Promise<Category[]> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.categories.getAll}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  search: async (term?: string): Promise<Category[]> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.categories.search(term)}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  getOne: async (reference: string): Promise<Category> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.categories.getOne(reference)}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  create: async (category: {
    name: string;
    description?: string;
  }): Promise<Category> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.categories.create}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(category),
      }
    );
    return response.json();
  },

  update: async (
    reference: string,
    category: { name: string; description?: string }
  ): Promise<Category> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.categories.update(reference)}`,
      {
        method: "PUT",
        headers: authHeadersJson(),
        body: JSON.stringify(category),
      }
    );
    return response.json();
  },

  delete: async (reference: string): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.categories.delete(reference)}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },
};
